import {Api} from '../../../application/api/api';

export default class OfferViewManager {
    /**
     *
     * @param {Element} listContentElement
     * @param {string} endpoint
     * @param {string} targetSelector
     */
    constructor(listContentElement, endpoint, targetSelector) {
        this.__listContentElement = listContentElement;
        this.__endpoint = endpoint;
        this.__targetSelector = targetSelector;
    }

    /**
     *
     * @return {NodeListOf<Element>}
     */
    detectAvailable() {
        return this.__listContentElement.querySelectorAll(this.__targetSelector);
    }

    /**
     *
     * @param {Array} offerList
     */
    notify(offerList) {
        let sendData = offerList.filter(function onlyUnique(value, index, array) {
            return array.indexOf(value) === index;
        })

        sendData = {values: sendData};

        Api.post(this.__endpoint, sendData, function () {});
    }
}
